<template>
  <div>
    <table class="table">
      <thead>
        <tr>
          <th scope="col">Nama Pemasok</th>
          <th scope="col">NO. PO</th>
          <th scope="col">NO. Surat Jalan</th>
          <th scope="col">Total</th>
          <th scope="col">Tanggal</th>
        </tr>
      </thead>
      <tbody
        v-for="(list, index) in items"
        :key="`parent-${index}`"
        class="border-0"
      >
        <tr
          v-for="(item, index) in list.items"
          :key="`child-${index}`"
        >
          <td class="text-capitalize">
            {{ item.subject && item.subject.name }}
          </td>
          <td
            class="text-primary"
            role="button"
            @click="detailPreOrder(item.reference.uuid)"
          >
            {{ item.reference.po_so_id }}
          </td>
          <td class="">
            <div v-if="item.reference.delivery_numbers">
              <span v-if="item.reference.delivery_numbers.length < 3">{{
                item.reference.delivery_numbers
                  .map((e) => e.delivery_number_note)
                  .slice(0, 3)
                  .join(', ')
              }}</span>
              <b-dropdown
                v-else
                :text="
                  item.reference.delivery_numbers
                    .map((e) => e.delivery_number_note)
                    .slice(0, 3)
                    .join(', ')
                "
                variant="flat-secondary"
                class="delivery-numbers px-0"
              >
                <b-row class="mx-0 pt-1">
                  <b-col
                    v-for="(item, index) in data.item.delivery_numbers"
                    :key="index"
                    class=""
                  >
                    <h6 class="text-dark">{{ item.delivery_number_note }}</h6>
                  </b-col>
                </b-row>
              </b-dropdown>
            </div>
          </td>
          <td class="">{{ formatToRupiah(item.total) }}</td>
          <td class="">{{ list.created_at | formatDateWithTime }}</td>
        </tr>
        <!-- <tr class="mt-1">
          <td
            colspan="4"
            class="border-0"
          >
            <h6
              class="font-weight-bolder mb-0 text-right"
              style="padding: 0 0.7rem"
            >
              Total {{ formatToRupiah(list.total) }}
            </h6>
          </td>
        </tr> -->
      </tbody>
      <tbody v-if="detailResultList.length === 0">
        <tr>
          <td
            colspan="4"
            class="text-center"
          >
            Data kosong.
          </td>
        </tr>
      </tbody>
    </table>
    <DetailSupplier
      v-if="result"
      :result="result"
    />
  </div>
</template>

<script>
import { BRow, BCol, BDropdown } from 'bootstrap-vue';

import AppCollapse from '@core/components/app-collapse/AppCollapse.vue';
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue';

import DetailSupplier from '@/components/Debt/Modal/Part/DetailSupplier.vue';

export default {
  name: 'UtangPayments',
  components: {
    BRow,
    BCol,
    BDropdown,
    AppCollapse,
    AppCollapseItem,
    DetailSupplier,
  },
  props: ['items'],
  data() {
    return {
      detailResultList: [
        {
          cash_total_payment: 501000,
          cash_change: 80,
          total: 500920,
          items: [
            {
              uuid: '6c2db703-5969-42f2-80f8-543cc9dc4d2b',
              no_invoice: 'INV/054/2025/02/17/0001',
              date: '15/04/2025',
              payment_number: 36237,
              subject: {
                formatted_id: '#143',
                uuid: '97e8ee9f-66d8-4030-984f-d778a7735bb6',
                name: 'sultan suplayer',
                phone_number: '62225413483',
                phone_number_country: null,
                tax_number: '232198129831928',
                address: '<p>Jl. Kebaktian99</p>',
                sales_name: 'Dina sales',
                sales_phone_number: '628948993899',
                sales_phone_number_country: null,
                payment_type: 'TOP',
                terms_of_payment_day: '60',
                sellers: [],
              },
              reference: {
                uuid: 'ec2fb1c8-c4c5-48f9-b82b-980625d44f25',
                invoice_number: null,
                is_stock_on_supplier: false,
                po_so_id: '2020',
                delivery_numbers: [
                  {
                    uuid: 'a31feaa4-8011-4a10-8f89-2be727e842ba',
                    delivery_number_note: '23232',
                    is_used: false,
                  },
                ],
                date: '17 Feb 2025',
                deleted_at: null,
                branch: {
                  name: 'Toko berkah jaya pertama',
                },
              },
              total: 500920,
            },
          ],
        },
      ],
      result: null,
    };
  },
  methods: {
    detailPreOrder(uuid) {
      this.$store
        .dispatch('stockWarehouse/getData', {
          uuid,
          params: '',
        })
        .then((result) => {
          if (result.data.data) {
            this.result = result.data.data;
            this.$bvModal.show('modal-detail-supplier');
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    formatToRupiah(amount) {
      const formatter = new Intl.NumberFormat('id-ID', {
        style: 'currency',
        currency: 'IDR',
        minimumFractionDigits: 0,
      });
      return formatter.format(amount);
    },
  },
};
</script>
